export default {
  data() {
    return {
      templateRows: [], // kept for compatibility, not used
    };
  },

  methods: {
    async fetchTemplates() {
      await this.$store.dispatch("EmailTemplatesStore/fetchList");
    },
  },

  computed: {
    resolvedRows() {
      return this.$store.getters["EmailTemplatesStore/resolvedRows"];
    },

    agentTemplates() {
      return this.$store.getters["EmailTemplatesStore/agentTemplates"];
    },

    customerTemplates() {
      return this.$store.getters["EmailTemplatesStore/customerTemplates"];
    },
  },
};
